import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from '../../../services/event-managers/toolbar-event-manager.helper';
import { DashboardHelper } from '../../../services/dashboard.service';
import * as AppConstants from '../../../modules/catch-core/data/constants/app.constants';

@Component({
  selector: 'app-agile-board-sort',
  templateUrl: './agile-board-sort.component.html',
  styleUrl: './agile-board-sort.component.scss',
  standalone: false,
})
export class AgileBoardSortComponent extends BaseComponent implements OnInit {
  public showAgileBoardSort: boolean = false;
  public sortDirection: 'asc' | 'desc' = 'asc';
  public selectedSortField: string = 'key';
  public sortIcon: string = 'pi pi-sort-amount-up';

  public readonly sortOptions: { label: string; value: string }[] = [
    { label: 'Key', value: 'key' },
    { label: 'Name', value: 'name' },
    { label: 'Priority', value: 'priority' },
    { label: 'Assignee', value: 'assignee' },
    { label: 'Due Date', value: 'dueDate' },
    { label: 'Created Date', value: 'createdDate' },
    { label: 'Modified Date', value: 'modifiedDate' },
    { label: 'Node Type', value: 'nodeType' },
  ];

  constructor(
    private dashboardHelper: DashboardHelper,
    private toolbarEventManagerHelper: ToolbarEventManagerHelper,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribers.currentApplication = this.dashboardHelper.$currentApplication.subscribe((res: any) => {
      if (res) {
        const currentAppName = res.displayName ? res.displayName.toLowerCase() : '';
        this.showAgileBoardSort = currentAppName === AppConstants.TRACK;
        this.cdr.detectChanges();
      }
    });

    this.subscribers.sortField = this.toolbarEventManagerHelper.$AgileBoardSortField.subscribe((field) => {
      this.selectedSortField = field;
    });

    this.subscribers.sortDirection = this.toolbarEventManagerHelper.$AgileBoardSortDirection.subscribe((direction) => {
      this.sortDirection = direction as 'asc' | 'desc';
      this.sortIcon = direction === 'asc' ? 'pi pi-sort-amount-up' : 'pi pi-sort-amount-down';
    });
  }

  public onSortFieldChange(field: string): void {
    if (!field) return;
    this.toolbarEventManagerHelper.AgileBoardSortDirection = 'asc';
    this.toolbarEventManagerHelper.AgileBoardSortField = field;
  }

  public onSortDirectionToggle(): void {
    const newDirection: 'asc' | 'desc' = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.toolbarEventManagerHelper.AgileBoardSortDirection = newDirection;
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
